module.exports = __webpack_public_path__ + "static/media/Meredith.36ce83bd.png";